import React from 'react'
import { Link } from 'react-router-dom'

import { NavBarEntry } from '@app/NavBar'

import { getClientsPath } from './paths'

export function useNavbarEntries(): NavBarEntry[] {
  return [
    {
      iconName: 'profile',
      title: 'Mandanten',
      EntryWrapper: ({ children }) => <Link to={getClientsPath()}>{children}</Link>,
      active: /^\/mandanten/
    }
  ]
}
